import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { COLOR, ChipsPendientes, Cabecera, Pagina, Seccion, fechaLarga, st } from "./reportesUi";

const COLOR_RUTA = { 1: "#0ea5a4", 2: "#16a34a", 3: "#9333ea" };

const TarjetaPiso = ({ p, fecha, onAbrir, onVer, onQuitar }) => {
  const color = p.hecho ? COLOR.ok : fecha ? COLOR.retr : COLOR.diario;
  return (
    <div style={{ ...st.tarjeta, borderColor: color, background: p.hecho ? "#f0fdf4" : "#fff", cursor: "pointer" }}
      onClick={p.hecho ? () => onVer(p) : () => onAbrir(p, fecha)}>
      <span style={{ fontSize: 30 }}>{p.hecho ? "✅" : "🏠"}</span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ ...st.abrev, display: "block", overflowWrap: "anywhere" }}>{p.abreviatura}</span>
        <span style={{ display: "flex", gap: 6, marginTop: 4, flexWrap: "wrap" }}>
          {p.ruta != null && <span style={{ background: COLOR_RUTA[p.ruta] || "#64748b", color: "#fff", borderRadius: 8, padding: "1px 9px", fontSize: 12, fontWeight: 800 }}>Ruta {p.ruta}</span>}
          {p.extra && <span style={{ background: "#e0e7ff", color: "#4338ca", borderRadius: 8, padding: "1px 9px", fontSize: 12, fontWeight: 800 }}>➕ añadido</span>}
        </span>
      </span>
      {p.hecho ? <span style={{ ...st.boton, background: COLOR.ok }}>👁 Ver</span>
        : <span style={{ ...st.boton, background: color }}>📝 Hacer</span>}
      {!p.hecho && p.extra && !fecha && (
        <button onClick={(e) => { e.stopPropagation(); onQuitar(p); }} title="Quitar del día" style={{ background: "#fee2e2", border: "none", color: "#dc2626", borderRadius: 10, width: 36, height: 36, fontSize: 16, fontWeight: 900, cursor: "pointer" }}>✕</button>
      )}
    </div>
  );
};

const ReportesDiario = () => {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [error, setError] = useState("");
  const [anadir, setAnadir] = useState(false);
  const [q, setQ] = useState("");

  const cargar = useCallback(() => {
    axios.get("/api/tareas/diario").then((r) => { setD(r.data); setError(""); }).catch(() => setError("❌ No se pudo cargar. Inténtalo de nuevo."));
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  const abrir = (p, fecha) => navigate("/supervisora/reporteDiario", { state: { piso: { id: p.id, abreviatura: p.abreviatura }, ...(fecha ? { fecha_dia: fecha } : {}) } });
  const ver = (p) => navigate("/supervisora/verReporteDiario", { state: { piso: { id: p.id, abreviatura: p.abreviatura } } });
  const anadirPiso = async (p) => {
    try { await axios.post("/api/tareas/diario/extra", { id_piso: p.id }); setAnadir(false); setQ(""); cargar(); }
    catch (e) { setError(e.response?.data?.error || "❌ No se pudo añadir el piso."); }
  };
  const quitar = async (p) => {
    try { await axios.delete(`/api/tareas/diario/extra/${p.id}`); cargar(); }
    catch (e) { setError(e.response?.data?.error || "❌ No se pudo quitar el piso."); }
  };

  const retrPorDia = useMemo(() => {
    const m = new Map();
    (d?.retrasados || []).forEach((x) => { if (!m.has(x.fecha)) m.set(x.fecha, []); m.get(x.fecha).push(x); });
    return [...m.entries()];
  }, [d]);
  const disponibles = useMemo(() => (d?.disponibles || []).filter((p) => p.abreviatura.toLowerCase().includes(q.trim().toLowerCase())), [d, q]);
  const hechos = d ? d.hoy.filter((p) => p.hecho).length : 0;

  return (
    <Pagina>
      <Cabecera titulo="Reporte diario" emoji="📋" color={COLOR.diario} onVolver={() => navigate("/supervisora/reportes")}>
        {d && <ChipsPendientes hoy={d.pte_hoy} retr={d.n_retrasados} grande />}
      </Cabecera>
      {error && <div style={{ background: "#fee2e2", color: "#b91c1c", borderRadius: 12, padding: "10px 14px", marginBottom: 12, fontWeight: 700 }}>{error}</div>}
      {!d && !error && <p style={{ textAlign: "center", color: "#64748b" }}>Cargando…</p>}
      {d && (
        <>
          <Seccion emoji="📅" titulo={`Hoy · ${hechos}/${d.hoy.length} hechos`} n={d.pte_hoy} color={COLOR.hoy} vacio={d.hoy.length ? "🎉 ¡Todos los de hoy hechos!" : "Hoy no te toca ningún piso"}>
            {d.hoy.map((p) => <TarjetaPiso key={p.id} p={p} onAbrir={abrir} onVer={ver} onQuitar={quitar} />)}
          </Seccion>
          <button onClick={() => setAnadir(true)} style={{ ...st.boton, background: "#4f46e5", width: "100%", padding: "14px", fontSize: 16, borderRadius: 16, marginTop: 4 }}>➕ Añadir otro piso</button>

          <Seccion emoji="⏰" titulo="Retrasados de esta semana" n={d.n_retrasados} color={COLOR.retr} vacio="🎉 No tienes retrasados">
            {retrPorDia.map(([fecha, lista]) => (
              <div key={fecha} style={{ marginBottom: 6 }}>
                <div style={{ fontWeight: 800, color: COLOR.retr, margin: "10px 2px 8px" }}>{fechaLarga(fecha)}</div>
                {lista.map((p) => <TarjetaPiso key={p.id + fecha} p={p} fecha={fecha} onAbrir={abrir} onVer={ver} onQuitar={quitar} />)}
              </div>
            ))}
          </Seccion>
        </>
      )}

      {anadir && (
        <div onClick={() => setAnadir(false)} style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", zIndex: 3000, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", width: "100%", maxWidth: 560, maxHeight: "80vh", borderRadius: "22px 22px 0 0", padding: 18, display: "flex", flexDirection: "column", boxSizing: "border-box" }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
              <h3 style={{ flex: 1, margin: 0, fontSize: 19, color: "#1e293b" }}>➕ Añadir piso a hoy</h3>
              <button onClick={() => setAnadir(false)} style={{ background: "#f1f5f9", border: "none", borderRadius: 10, width: 38, height: 38, fontSize: 18, cursor: "pointer" }}>✕</button>
            </div>
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="🔎 Buscar piso…" style={{ padding: "12px 14px", borderRadius: 12, border: "1.5px solid #cbd5e1", fontSize: 16, marginBottom: 10 }} />
            <div style={{ overflowY: "auto" }}>
              {disponibles.length === 0 && <p style={{ textAlign: "center", color: "#94a3b8" }}>No hay pisos que coincidan</p>}
              {disponibles.map((p) => (
                <button key={p.id} onClick={() => anadirPiso(p)} style={{ display: "flex", width: "100%", alignItems: "center", gap: 10, padding: "13px 14px", marginBottom: 8, borderRadius: 14, border: "1.5px solid #e2e8f0", background: "#f8fafc", fontSize: 17, fontWeight: 800, color: "#1e3a5f", cursor: "pointer", textAlign: "left", fontFamily: "inherit" }}>
                  🏠 <span style={{ flex: 1, overflowWrap: "anywhere" }}>{p.abreviatura}</span>
                  {p.ruta != null && <span style={{ background: COLOR_RUTA[p.ruta] || "#64748b", color: "#fff", borderRadius: 8, padding: "1px 9px", fontSize: 12 }}>Ruta {p.ruta}</span>}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </Pagina>
  );
};

export default ReportesDiario;
